const moment = require('moment');

const calcularFechas = () => {

    let fechasOption = {}
    let año = moment().year();
    let mes = moment().format("DD/MM/YYYY").split("/")[1]
    let arrayDias = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"]
    let isDateExpire = false;
    let mediadoMes = moment(`15/${mes}/${año}`, 'DD/MM/YYYY');
    let finDeMes = mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY') : moment(`30/${mes}/${año}`, 'DD/MM/YYYY');
    let mediadoMesExpirada = false;
    let finDeMesExpirada = false;
    let hoy = moment();

    let diffConMediadoMes = mediadoMes.diff(hoy, 'days');
    let diffFinDeMes = finDeMes.diff(hoy, 'days');

    /* console.log("diffConMediadoMes", diffConMediadoMes);
    console.log("diffFinDeMes", diffFinDeMes); */

    if (diffConMediadoMes < 0) {
        isDateExpire = true;
        mediadoMesExpirada = true;
    }

    if (diffFinDeMes < 0) {
        isDateExpire = true;
        finDeMesExpirada = true;
    }

    if (isDateExpire) {

        if (!mediadoMesExpirada) {

            if (moment(`15/${mes}/${año}`, 'DD/MM/YYYY').diff(hoy, 'days') < 8) {

                fechasOption = {
                    fecha1: moment(`15/${mes}/${año}`, 'DD/MM/YYYY').add(15, 'days'),
                    fecha2: moment(`15/${mes}/${año}`, 'DD/MM/YYYY').add(30, 'days'),
                    fecha1Day: arrayDias[moment(`15/${mes}/${año}`, 'DD/MM/YYYY').add(15, 'days').day()],
                    fecha2Day: arrayDias[moment(`15/${mes}/${año}`, 'DD/MM/YYYY').add(30, 'days').day()]
                }
                return fechasOption;

            } else {
                fechasOption = {
                    fecha1: mediadoMes,
                    fecha2: finDeMes,
                    fecha1Day: arrayDias[mediadoMes.day()],
                    fecha2Day: arrayDias[finDeMes.day()]
                }
                return fechasOption;
            }

        } else {

            //console.log(moment(`28/${mes}/${año}`, 'DD/MM/YYYY').diff(hoy, 'days') < 8 ? "ES MENOR A 8" : "ES MAYOR A 8");

            if (mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY').diff(hoy, 'days') < 8 :  moment(`30/${mes}/${año}`, 'DD/MM/YYYY').diff(hoy, 'days') < 8) {

                let monthFinalDay = mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY') : moment(`30/${mes}/${año}`, 'DD/MM/YYYY');
                let monthFinal = mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY') : moment(`30/${mes}/${año}`, 'DD/MM/YYYY');
                fechasOption = {
                    fecha1: monthFinalDay.add(15, 'days'),
                    fecha2: mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY').add(30, 'days') : moment(`30/${mes}/${año}`, 'DD/MM/YYYY').add(30, 'days'),
                    fecha1Day: arrayDias[mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY').add(15, 'days') : moment(`30/${mes}/${año}`, 'DD/MM/YYYY').add(15, 'days').day()],
                    fecha2Day: arrayDias[monthFinal.add(30, 'days').day()]
                }
                return fechasOption;
            }
            else {
                let monthFinalDay = mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY') : moment(`30/${mes}/${año}`, 'DD/MM/YYYY');
                let monthFinal = mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY') : moment(`30/${mes}/${año}`, 'DD/MM/YYYY');

                fechasOption = {
                    fecha1: finDeMes,
                    fecha2: monthFinalDay.add(15, 'days'),
                    fecha1Day: arrayDias[finDeMes.day()],
                    fecha2Day: arrayDias[monthFinal.add(15, 'days').day()]
                }
                return fechasOption;
            }
        }
    } else {
        if (mediadoMes.diff(hoy, 'days') < 8) {
            fechasOption = {
                fecha1: finDeMes,
                fecha2: moment(mes === '02' ? `28/${mes}/${año}` : `30/${mes}/${año}`, 'DD/MM/YYYY').add(15, 'days'),
                fecha1Day: arrayDias[mes === '02' ?  moment(`28/${mes}/${año}`, 'DD/MM/YYYY').day() : moment(`30/${mes}/${año}`, 'DD/MM/YYYY').day()],
                fecha2Day: arrayDias[mes === '02' ? moment(`28/${mes}/${año}`, 'DD/MM/YYYY').add(15, 'days').day() : moment(`30/${mes}/${año}`, 'DD/MM/YYYY').add(15, 'days').day()]
            }
        } else {
            fechasOption = {
                fecha1: mediadoMes,
                fecha2: finDeMes,
                fecha1Day: arrayDias[mediadoMes.day()],
                fecha2Day: arrayDias[finDeMes.day()]
            }
        }
        return fechasOption;
    }
}

/* const options = calcularFechas()
console.log(options); */

module.exports = {
    calcularFechas
}
